<template>
  <div class="contact-us">
    <h1>聯繫我們</h1>
    <div class="item">
      line客服：
      <div class="link">
        <a href="https://line.me/ti/p/hT2U1C1Qn6" target="_blank">3uplay</a>
      </div>
    </div>
    <div class="item">
      公司地址：
      <div class="link">
        高雄市荟雅匾中正一路1205楼之4
      </div>
    </div>
    <div class="item">
      郵箱：
      <div class="link">
        <a href="mailto:nicee00001@gmail.com">nicee00001@gmail.com</a>
      </div>
    </div>
    <div class="item">
      電話：
      <div class="link">
        <a href="tel:075225937">(07)5225937</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ContactUs',
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.contact-us {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 100px;
}
h1 {
  margin-bottom: 50px;
}
.item {
  display: flex;
  margin-bottom: 30px;
  font-size: 18px;
  font-weight: bold;
  color: #666;
}
.link {
  color: #6b39ff;
  a {
    color: #6b39ff;
    cursor: pointer;
  }
}
</style>
